import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent {
  constructor() { }
}
